<!--
 * @Author: your name
 * @Date: 2021-01-05 11:20:09
 * @LastEditTime: 2021-01-06 21:36:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\email\info.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link target="_blank" class="routerLink" to="/home">
          阳光校务服务大厅
        </router-link>
        &gt;
        <router-link target="_blank" class="routerLink" to="/lostAndFound">
          失物招领
        </router-link>
        &gt; 正文
      </div>
    </div>
    <!-- <div class="orgTitle center" style="margin-top: 40px">
      阳光校务服务中心信息员联系电话
    </div>
    <div class="orgTime center">
      文字来源：本站原创  发布时间： 2021年01月06日 10:41:23
    </div> -->
    <div class="body" style="margin-top: 25px">
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">物品名称：</div>
        <div class="bodyRowItem row" :title="info.name" style="width: 85%">
          {{ info.name }}
        </div>
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">物品描述：</div>
        <div class="bodyRowItem row" style="width: 85%">
          {{ info.content }}
        </div>
      </div>
      <div v-if="info.type === 1" class="bodyRow">
        <div class="bodyRowItem noBorder">遗失地点：</div>
        <div class="bodyRowItem row" style="width: 85%">
          {{ info.lostAddress }}
        </div>
      </div>
      <div v-else class="bodyRow">
        <div class="bodyRowItem noBorder">拾取地点：</div>
        <div class="bodyRowItem row" style="width: 85%">
          {{ info.pickUp }}
        </div>
      </div>
      <div v-if="info.type === 1" class="bodyRow">
        <div class="bodyRowItem noBorder">遗失时间：</div>
        <div class="bodyRowItem row" style="width: 85%">
          {{ info.lostTime }}
        </div>
      </div>
      <div v-else class="bodyRow">
        <div class="bodyRowItem noBorder">拾取时间：</div>
        <div class="bodyRowItem row" style="width: 85%">
          {{ info.lostTime }}
        </div>
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">返还地点：</div>
        <div class="bodyRowItem row" style="width: 85%">
          {{ info.returnAddress ? info.returnAddress : "" }}
        </div>
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">联系人：</div>
        <div class="bodyRowItem row" style="width: 85%">
          {{ info.userName }}
        </div>
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">联系电话：</div>
        <div class="bodyRowItem row" style="width: 85%">{{ info.mobile }}</div>
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">附件：</div>
        <div class="bodyRowItem row" style="width: 85%">
          <a v-if="info.filePath" @click="down(info.filePath)">{{
              info.filePath
            }}</a>
          <span v-else>无</span>
        </div>
      </div>
      <div class="bodyRow noBorder">
        <div class="bodyRowItem noBorder">失物状态：</div>
        <div
            class="bodyRowItem row"
            :style="info.status === 1 ? 'color:#f00' : 'color:green'"
            style="width: 85%"
        >
          {{ info.status === 1 ? "寻找中" : "失主已找到，宝贝已回家！" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAction} from "@/api/manage";

export default {
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    down(path) {
      window.open(
          window._CONFIG["url"] + "/common/file/downLoadByJava" + "?path=" + path
      );
    },
    getInfo() {
      let record = JSON.parse(decodeURIComponent(this.$route.query.record));
      getAction('/user/lost/details', {id: record.id}).then((data) => {
        if (data.code === 0) {
          this.info = data.data
        } else {
          this.$message.error(data.message)
        }
      })
    },
  },
};
</script>

<style scoped>
.center {
  width: 100%;
  text-align: center;
}

.orgTitle {
  padding-top: 20px;
  font-family: 宋体;
  font-size: 22pt;
  font-weight: bold;
}

.orgTime {
  padding-top: 10px;
  font-size: 12px;
  color: #999;
}

.orgTitle2 {
  font-weight: bold;
  margin-top: 15px;
  font-family: 仿宋_GB2312;
  font-size: 14pt;
}

.body {
  border: 1px solid #e6e6e6;
  margin-top: 10px;
}

.bodyRow {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
}

.bodyRowItem {
  padding: 10px;
  border-left: 1px solid #e6e6e6;
  width: 15%;
  height: 100%;
}

.noBorder {
  border: none;
}

.row {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-height: 40px;
}
</style>
